import { useTheme as StyledComponentsUseTheme } from 'styled-components'

const useTheme = StyledComponentsUseTheme as () => Theme

export default useTheme
